import React from 'react';
import * as mobxReact from 'mobx-react';
import * as mobx from 'mobx';
import * as IoC from 'typescript-ioc';
import { GenerateRoomsVM } from '../../generate-rooms.viewmodel';
import { FormField } from '../../../../../../global/form/form-field/form-field';
import { IDateTimeFormatter } from '../../../../../../../infrastructure/date-formatter';
import { DefaultDatePicker } from '../../../../../../global/default-datepicker/default-datepicker';
import { OERadioSingleOption } from '../../../../../../global/oe-radio-options/oe-radio-single-option';
import { GENERATE_ROOMS_MESSAGE_TEXT } from '../../generate-rooms-form.text';
import { OERadioOptions } from '../../../../../../global/oe-radio-options/oe-radio-options';
import { ConnectionVersion } from '../../../../../../../constants/common.constants';
import { connectionVersionOptions } from '../../../../_meetings-list/_assign-room/_assign-room-form/assign-room-form-data.viewmodal';

const GenerateRoomsFormPresentation = mobxReact.observer((props: { vm: GenerateRoomsVM }) => {
    const dateTimeFormatter = IoC.Container.get(IDateTimeFormatter);
    const formData = props.vm.getFormDataVM();
    const startTimeErrorClassName = formData.isFormChecked() && formData.getStartTimeError() ? 'oe-form-field__control--error' : '';
    const endTimeErrorClassName = formData.isFormChecked() && formData.getEndTimeError() ? 'oe-form-field__control--error' : '';

    return (
        <form className='oe-form'>
            <div className='oe-form__body'>
                <FormField>
                    <div className='oe-form-field__radio-group'>
                        <OERadioSingleOption
                            option={{
                                label: 'Assign one room per Presenter, per day'
                            }}
                            value={'Assign one room per Presenter, per day'}
                            onToggle={null}
                            disabled={true}
                            checked={true}
                        />
                    </div>
                </FormField>
                <FormField label='Start Time'>
                    <DefaultDatePicker
                        className={`oe-form-field__control ${startTimeErrorClassName}`}
                        name='startDateTime'
                        selected={formData.startTimeDate}
                        onChange={mobx.action(date => formData.startTimeDate = date)}
                        showTimeSelectOnly={true}
                        dateformat={dateTimeFormatter.getLocalTimeFormat()}
                        timeCaption='Time'
                    />
                    {formData.isFormChecked() && (
                        <span className='oe-form-field__error'>{formData.getStartTimeError()}</span>
                    )}
                </FormField>
                <FormField label='End Time'>
                    <DefaultDatePicker
                        className={`oe-form-field__control ${endTimeErrorClassName}`}
                        name='endDateTime'
                        selected={formData.endTimeDate}
                        onChange={mobx.action(date => formData.endTimeDate = date)}
                        showTimeSelectOnly={true}
                        dateformat={dateTimeFormatter.getLocalTimeFormat()}
                        timeCaption='Time'
                    />
                    {formData.isFormChecked() && (
                        <span className='oe-form-field__error'>{formData.getEndTimeError()}</span>
                    )}
                </FormField>
                <p>{ props.vm.intl.formatMessage(GENERATE_ROOMS_MESSAGE_TEXT) }</p>
                <FormField>
                    <OERadioOptions
                        value={formData.connectionVersion}
                        onOptionToggle={(value: ConnectionVersion) => formData.setConnectionVersionField(value)}
                        options={connectionVersionOptions(props.vm.intl)}
                        isIconFirst
                    />
                </FormField>
            </div>
        </form>
    );
});

export { GenerateRoomsFormPresentation };
